module.exports = __webpack_public_path__ + "img/warn.e4e8f32d.png";